import React from 'react';
import cn from '@/utils/cn';

interface PrintAssessmentOptionProps {
  iconClass: string;
  text: string;
}

const PrintAssessmentOption = ({ iconClass, text }: PrintAssessmentOptionProps) => (
  <span className="tw-flex tw-items-center">
    <i
      aria-hidden="true"
      className={cn(
        'fa',
        iconClass,
        'tw-mr-2 tw-text-tci-purple tw-text-lg tw-inline-block tw-w-[18px] tw-text-center',
      )}
    />
    {text}
  </span>
);

export default PrintAssessmentOption;
